import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { AddressAutocomplete } from "@/components/AddressAutocomplete";

export const todayYMD = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const EMPTY_TENANT = {
  first_name: "", surname: "", phone: "", email: "", address: "", notes: "", gate_fob: "",
  move_in_date: "", notice_given_date: "", move_out_date: "",
};

const DateField = ({ label, k, form, set, id }) => (
  <div className="space-y-1.5">
    <Label className="text-xs text-slate-600">{label}</Label>
    <Input data-testid={id} type="date" value={form[k] || ""} onChange={(e) => set(k, e.target.value)} />
  </div>
);

// Shared tenant details form used by the unit drawer, Move In dialog and Waitlist Assign dialog
export const TenantFields = ({ form, set, prefix, sizeSlot = null }) => (
  <div className="space-y-4" data-testid={`${prefix}-tenant-fields`}>
    <div className="grid grid-cols-2 gap-3">
      <div className="space-y-1.5"><Label>First Name</Label><Input data-testid={`${prefix}-first-name`} value={form.first_name} onChange={(e) => set("first_name", e.target.value)} placeholder="First name" /></div>
      <div className="space-y-1.5"><Label>Surname</Label><Input data-testid={`${prefix}-surname`} value={form.surname} onChange={(e) => set("surname", e.target.value)} placeholder="Surname" /></div>
    </div>
    <div className="grid grid-cols-2 gap-3">
      <div className={sizeSlot ? "space-y-1.5" : "space-y-1.5 col-span-2 sm:col-span-1"}><Label>Phone</Label><Input data-testid={`${prefix}-phone`} value={form.phone} onChange={(e) => set("phone", e.target.value)} /></div>
      {sizeSlot || <div className="space-y-1.5 col-span-2 sm:col-span-1"><Label>Email</Label><Input data-testid={`${prefix}-email`} value={form.email} onChange={(e) => set("email", e.target.value)} /></div>}
    </div>
    {sizeSlot && <div className="space-y-1.5"><Label>Email</Label><Input data-testid={`${prefix}-email`} value={form.email} onChange={(e) => set("email", e.target.value)} /></div>}
    <div className="space-y-1.5"><Label>Gate Fob Number</Label><Input data-testid={`${prefix}-gate-fob`} value={form.gate_fob} onChange={(e) => set("gate_fob", e.target.value)} placeholder="e.g. FOB-0421" /></div>
    <div className="space-y-1.5"><Label>Address</Label><AddressAutocomplete value={form.address} onChange={(v) => set("address", v)} /></div>
    <div className="space-y-1.5"><Label>Tenant Notes</Label><Textarea data-testid={`${prefix}-notes`} rows={3} value={form.notes} onChange={(e) => set("notes", e.target.value)} placeholder="Add notes about this unit or tenant..." /></div>
    <div className="pt-3 border-t border-slate-200 space-y-3">
      <Label className="text-xs font-bold text-slate-700 uppercase tracking-wider block">Tenancy Timeline</Label>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <DateField label="Move-in Date" k="move_in_date" form={form} set={set} id={`${prefix}-move-in-date`} />
        <DateField label="Notice Given Date" k="notice_given_date" form={form} set={set} id={`${prefix}-notice-given-date`} />
        <DateField label="Move-out Date" k="move_out_date" form={form} set={set} id={`${prefix}-move-out-date`} />
      </div>
    </div>
  </div>
);
